import { GraduationCap, Target, Telescope, TrendingUp, Wrench } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { InfoNote } from "@/components/InfoNote";

const CARDS: { id: string; icon: LucideIcon; title: string; body: string }[] = [
    {
        id: "problems",
        icon: Target,
        title: "problems_i_enjoy_solving",
        body:
            "anything where messy input has to become trustworthy output. dense documents that need to become structured data. answers that need receipts. slow things that nobody measured — the legacy app that went from 2–3 minutes to under 10 seconds is still my favourite kind of afternoon. the common thread: problems where the fix is understanding the system, not adding more to it.",
    },
    {
        id: "tech",
        icon: Telescope,
        title: "tech_to_explore",
        body:
            "evaluation frameworks for RAG and agents (vibes don't scale). agent orchestration beyond a single graph — langchain internals first, since the fork is already open. vector search at a size where the naive approach stops working. streaming architectures, because real-time audio was the most fun i've had debugging. and enough infrastructure — docker, CI, deployment — that shipping stops being a separate skill.",
    },
    {
        id: "skills",
        icon: TrendingUp,
        title: "skills_to_improve",
        body:
            "writing tests before i need them, not after something breaks. system design at a scale i haven't hit yet. reading other people's codebases quickly instead of rewriting them in my head. explaining technical work to people who don't want the architecture diagram — toastmasters is quietly a software skill. and knowing when 'works' is genuinely done.",
    },
    {
        id: "projects",
        icon: Wrench,
        title: "projects_i_might_build",
        body:
            "a knowledge graph over my own notes and bookmarks, so the 37 tabs finally become searchable by meaning. a practice logger for the saxophone that listens and tells me which notes i keep rushing. an evaluation harness that scores my RAG answers honestly. and something small and useless and delightful — every portfolio needs one. (this OS was that one.)",
    },
    {
        id: "engineer",
        icon: GraduationCap,
        title: "the_engineer_i_want_to_become",
        body:
            "the kind of engineer who measures before judging, ships before perfecting, and leaves code the next person can read without a meeting. who can take an AI feature from 'demo that impresses' to 'system you can trust with real numbers'. curious enough to keep opening tabs, disciplined enough to eventually close some.",
    },
];

export function FutureExe() {
    return (
        <div data-testid="future-exe">
            <p className="font-mono text-[11px] text-inkfaint">
                status: under construction, on purpose. this file updates as i do. nothing below is a promise — it's a direction.
            </p>
            <div className="mt-4 space-y-3">
                {CARDS.map((c) => {
                    const Icon = c.icon;
                    return (
                        <div key={c.id} className="rounded-2xl border-2 border-ink bg-paper p-4 shadow-[3px_3px_0_#1C1917]" data-testid={`future-card-${c.id}`}>
                            <div className="flex items-center gap-2">
                                <span className="grid h-8 w-8 flex-none place-items-center rounded-lg border-2 border-ink bg-lavsoft text-lav">
                                    <Icon size={16} />
                                </span>
                                <p className="font-mono text-[12px] font-bold">{c.title}</p>
                            </div>
                            <div className="mt-3">
                                <InfoNote text={c.body} testId={`future-${c.id}`} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
